const clauses = [
  {
    id: "50.1",
    title: "AI interaction disclosure",
    desc: "Chatbots, voice assistants, and any AI users talk to must tell them they are interacting with a machine.",
    footer: "Non-compliance: administrative fines per incident.",
    severity: "high",
  },
  {
    id: "50.2",
    title: "Synthetic content marking",
    desc: "AI-generated or edited images, audio, video, and text must carry a machine-readable mark (C2PA or equivalent).",
    footer: "Affects every camera, editor, and content tool shipping to the EU.",
    severity: "high",
  },
  {
    id: "50.3",
    title: "Emotion & biometric categorisation",
    desc: "Emotion recognition and biometric categorisation systems must disclose the inference to affected users.",
    footer: "Special category personal data — heightened exposure.",
    severity: "medium",
  },
  {
    id: "50.4",
    title: "Deepfakes & public-interest text",
    desc: "AI-generated or manipulated likenesses (deepfakes) and AI text on matters of public interest must be labelled as such.",
    footer: "Often the highest-visibility failure — reputational risk included.",
    severity: "high",
  },
];

export default function Clauses() {
  return (
    <section id="obligations" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="section-head">
          <p className="eyebrow">
            <i className="ri-article-line" />
            Article 50
          </p>
          <h2 className="section-title">
            What the regulation actually requires
          </h2>
          <p className="section-lede">
            Plain-English summary of the four obligations every deployer of an AI system interacting with people must meet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {clauses.map((clause) => (
            <article
              key={clause.id}
              className="card hover:shadow-lg hover:shadow-background-200/50 transition-all duration-300"
            >
              <div className="flex items-start gap-3 mb-3">
                <span className={`inline-flex items-center justify-center px-2.5 py-1 rounded-md text-xs font-bold ${
                  clause.severity === "high"
                    ? "bg-accent-100 text-accent-700"
                    : "bg-secondary-100 text-secondary-700"
                }`}>
                  {clause.id}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900">
                  {clause.title}
                </h3>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {clause.desc}
              </p>
              <footer className="pt-3 border-t border-background-200/70">
                <p className="text-xs text-foreground-500">{clause.footer}</p>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}